import React from 'react';
import PropTypes from 'prop-types';
import SimpleCard from './SimpleCard';
import './InfoCard.css';

const InfoCard = ({ title, items, className, headerStyle, noBorder, style }) => (
  <SimpleCard title={title} className={className} headerStyle={headerStyle} style={style} noBorder={noBorder}>
    <div className="px-4 py-3">
      {items.map((item, itemIndex) => (
        <div key={itemIndex} className="d-flex align-items-center info-card-row">
          <label className="info-card-row-label" htmlFor={item.labelFor} style={{ width: '30%' }}>
            {item.label}
          </label>
          <div id={item.labelFor} className="info-card-row-value">
            {item.value}
          </div>
        </div>
      ))}
    </div>
  </SimpleCard>
);

InfoCard.propTypes = {
  title: PropTypes.node.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      labelFor: PropTypes.string.isRequired,
      alignCenter: PropTypes.bool,
      style: PropTypes.object,
      value: PropTypes.node.isRequired,
    }),
  ).isRequired,
  className: PropTypes.string,
  headerStyle: PropTypes.object,
  noBorder: PropTypes.bool,
  style: PropTypes.object,
};

InfoCard.defaultProps = {
  className: '',
  headerStyle: {},
  noBorder: true,
  style: {},
};

export default InfoCard;
